export const COMMUNES = [
  {
    nom: "Les Avirons",
    code: "97401",
    codeDepartement: "974",
    siren: "219740016",
    codeEpci: "249740077",
    codeRegion: "04",
    codesPostaux: ["97425"],
    population: 11434,
  },
  {
    nom: "Bras-Panon",
    code: "97402",
    codeDepartement: "974",
    siren: "219740024",
    codeEpci: "249740093",
    codeRegion: "04",
    codesPostaux: ["97412"],
    population: 13344,
  },
  {
    nom: "Entre-Deux",
    code: "97403",
    codeDepartement: "974",
    siren: "219740032",
    codeEpci: "249740085",
    codeRegion: "04",
    codesPostaux: ["97414"],
    population: 7105,
  },
  {
    nom: "L'Étang-Salé",
    code: "97404",
    codeDepartement: "974",
    siren: "219740040",
    codeEpci: "249740077",
    codeRegion: "04",
    codesPostaux: ["97427"],
    population: 13836,
  },
  {
    nom: "Petite-Île",
    code: "97405",
    codeDepartement: "974",
    siren: "219740057",
    codeEpci: "249740077",
    codeRegion: "04",
    codesPostaux: ["97429"],
    population: 12617,
  },
  {
    nom: "La Plaine-des-Palmistes",
    code: "97406",
    codeDepartement: "974",
    siren: "219740065",
    codeEpci: "249740093",
    codeRegion: "04",
    codesPostaux: ["97431"],
    population: 6821,
  },
  {
    nom: "Le Port",
    code: "97407",
    codeDepartement: "974",
    siren: "219740073",
    codeEpci: "249740101",
    codeRegion: "04",
    codesPostaux: ["97420"],
    population: 33336,
  },
  {
    nom: "La Possession",
    code: "97408",
    codeDepartement: "974",
    siren: "219740081",
    codeEpci: "249740101",
    codeRegion: "04",
    codesPostaux: ["97419"],
    population: 35245,
  },
  {
    nom: "Saint-André",
    code: "97409",
    codeDepartement: "974",
    siren: "219740099",
    codeEpci: "249740093",
    codeRegion: "04",
    codesPostaux: ["97440"],
    population: 57150,
  },
  {
    nom: "Saint-Benoît",
    code: "97410",
    codeDepartement: "974",
    siren: "219740107",
    codeEpci: "249740093",
    codeRegion: "04",
    codesPostaux: ["97437", "97470"],
    population: 37023,
  },
  {
    nom: "Saint-Denis",
    code: "97411",
    codeDepartement: "974",
    siren: "219740115",
    codeEpci: "249740119",
    codeRegion: "04",
    codesPostaux: ["97400", "97417", "97490"],
    population: 154765,
  },
  {
    nom: "Saint-Joseph",
    code: "97412",
    codeDepartement: "974",
    siren: "219740123",
    codeEpci: "249740085",
    codeRegion: "04",
    codesPostaux: ["97480"],
    population: 38807,
  },
  {
    nom: "Saint-Leu",
    code: "97413",
    codeDepartement: "974",
    siren: "219740131",
    codeEpci: "249740101",
    codeRegion: "04",
    codesPostaux: ["97416", "97424", "97436"],
    population: 34893,
  },
  {
    nom: "Saint-Louis",
    code: "97414",
    codeDepartement: "974",
    siren: "219740149",
    codeEpci: "249740077",
    codeRegion: "04",
    codesPostaux: ["97421", "97450"],
    population: 53935,
  },
  {
    nom: "Saint-Paul",
    code: "97415",
    codeDepartement: "974",
    siren: "219740156",
    codeEpci: "249740101",
    codeRegion: "04",
    codesPostaux: ["97411", "97422", "97423", "97434", "97435", "97460"],
    population: 105240,
  },
  {
    nom: "Saint-Pierre",
    code: "97416",
    codeDepartement: "974",
    siren: "219740164",
    codeEpci: "249740077",
    codeRegion: "04",
    codesPostaux: ["97410", "97432"],
    population: 84077,
  },
  {
    nom: "Saint-Philippe",
    code: "97417",
    codeDepartement: "974",
    siren: "219740172",
    codeEpci: "249740085",
    codeRegion: "04",
    codesPostaux: ["97442"],
    population: 5074,
  },
  {
    nom: "Sainte-Marie",
    code: "97418",
    codeDepartement: "974",
    siren: "219740180",
    codeEpci: "249740119",
    codeRegion: "04",
    codesPostaux: ["97438"],
    population: 34344,
  },
  {
    nom: "Sainte-Rose",
    code: "97419",
    codeDepartement: "974",
    siren: "219740198",
    codeEpci: "249740093",
    codeRegion: "04",
    codesPostaux: ["97439"],
    population: 6343,
  },
  {
    nom: "Sainte-Suzanne",
    code: "97420",
    codeDepartement: "974",
    siren: "219740206",
    codeEpci: "249740119",
    codeRegion: "04",
    codesPostaux: ["97441"],
    population: 24293,
  },
  {
    nom: "Salazie",
    code: "97421",
    codeDepartement: "974",
    siren: "219740214",
    codeEpci: "249740093",
    codeRegion: "04",
    codesPostaux: ["97433"],
    population: 7243,
  },
  {
    nom: "Le Tampon",
    code: "97422",
    codeDepartement: "974",
    siren: "219740222",
    codeEpci: "249740085",
    codeRegion: "04",
    codesPostaux: ["97418", "97430"],
    population: 81943,
  },
  {
    nom: "Les Trois-Bassins",
    code: "97423",
    codeDepartement: "974",
    siren: "219740230",
    codeEpci: "249740101",
    codeRegion: "04",
    codesPostaux: ["97426"],
    population: 6899,
  },
  {
    nom: "Cilaos",
    code: "97424",
    codeDepartement: "974",
    siren: "219740248",
    codeEpci: "249740077",
    codeRegion: "04",
    codesPostaux: ["97413"],
    population: 5390,
  },
];

export const COMMUNES_OPTIONS = COMMUNES.map((commune) => {
  const rawName = commune.nom || "";
  const slug = rawName
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

  return {
    id: slug,
    name: rawName,
  };
});
